import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withHashLocation } from '@angular/router';
import { AbstractSecurityStorage, authInterceptor, DefaultLocalStorageService, provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TimeagoModule } from 'ngx-timeago';
import { userInactiveInterceptor } from './shared/interceptors/user-inactive.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
      provideHttpClient(withInterceptors([authInterceptor(), userInactiveInterceptor])),

      provideAuth({
        config: environment.auth
      },withAppInitializerAuthCheck()),
      MessageService,
      ConfirmationService,
      {
        provide: AbstractSecurityStorage,
        useClass: DefaultLocalStorageService,
      },
      importProvidersFrom(
        TimeagoModule.forRoot()
      ),
      provideAnimations(),
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(routes, withHashLocation(),withComponentInputBinding())
  ]
};
